{
    "coordinates": [
        39.59513408745693,
        -9.000824134849353
    ],
    "tooltip": "Guimarota",
    "title": "Alcobaça Formation (Guimarota)",
    "country": "Portugal",
    "period": "Jurassic",
    "alt": "TODO"
}
